export const ProjectThresholdData =
{
    name: String,
    projectId: String,
    globalThresholdValue: String,
    globalThresholdPercent: String,
    createdBy: String,
    users: Array
}